(function($, undefined) {
	
	'use strict';
	var notificationUtils;
	var accountUtils;
	var customSelect;
	
	var win = $(window);
	var winWidth;
	var winHeight;
	var form;
	var auditionId;
	var auditionState;
	var publishCtn;
	var currForm;
	var formSubmit;
	var stepHeader;
	var stepNextBtn;
	var stepHeight;
	var addStudioDate;
	var directivesInput;
	var scriptsInput;
	var scriptAdd;
	var auditionType;
	var recordingCheck;
	var checkingPageLeave = false;
	var pageLeaveUrl;
	var redirect;
	var redirectInvites;
	var popupRedirect;
	var searcherId;
	var sendEditNotificationCheck;
	var sendInvitesPopupBtn;
    
	var studioChk;
	var sourceConnectChk;
	
	var submitAudition = function (e) {
		e.preventDefault();
		e.stopPropagation();
        if (currForm.hasClass('is-processing')) {
            return false;
        }
        
		var t = $(this);
		var gotoDetail = false;
		var gotoStay = t.hasClass('stay');
		var goToInvites = false;
		var preview = t.hasClass('preview');
		var isVideo = $('.form-input[name="field19"]').val() === '1';
		var recordingCtn = isVideo ? $('.audition-recording-inputs.video-input') : $('.audition-recording-inputs.audio-input');
		redirect = publishCtn.attr('data-redirect-detail');
		redirectInvites = publishCtn.attr('data-redirect-invite');

		if (!preview) {
			form.validateForm(currForm, true);
		}
		
		if (!currForm.hasClass('has-error') || preview) {
			var recordingDates = $('.account-option-item[data-rel="audition-recording-dates"]:not(.clone)', recordingCtn);
			var $scripts = $('.audition-form-script-item:not(.clone)');

			if ($scripts.length || preview) {
				if ((recordingDates.length && (($('.audition-forms-recording-responsable:checked').val() === 'false' && !isVideo) || isVideo)) || ($('.audition-forms-recording-responsable:checked').val() === 'true' && !isVideo) || preview) {
					var id = auditionId;
					var limit = $('.form-input[name="limit"]').val();
					var recResponsableDate = $('.form-input[name="audition-forms-recording-responsable-date"]').val();
					var publish = $('.auditions-form-publish-check').is(':checked');
					var auditionType = $('.form-input[name="field2"]').attr('data-value');
					var sendEditNotification = false;
                    var history = ($('input[name="edit-notification-detail-history"]').length === 0 || $('input[name="edit-notification-detail-history"]').val() === '') ? {} : JSON.parse($('input[name="edit-notification-detail-history"]').val());
                   
					currForm.addClass('is-processing');
					
					if (id === undefined) {
						var currDate = new Date();
						
						$('input[name="dateField1Year"]').val(currDate.getFullYear());
						$('input[name="dateField1Month"]').val(currDate.getMonth());
						$('input[name="dateField1Day"]').val(currDate.getDate());
						$('input[name="dateField1Hour"]').val(currDate.getHours());
						$('input[name="dateField1Minute"]').val(currDate.getMinutes());
						$('input[name="dateField1Second"]').val(currDate.getSeconds());
					} else {                        
                        sendEditNotification = $('.auditions-form-notify-check').is(':checked');
                        
                        var edit = $('.form-input[name="send-notification-detail"]').length > 0 ? tinymce.get($('.form-input[name="send-notification-detail"]').attr('id')).getContent() : '';
                        if (edit !== '') {
                            var currDate = new Date();
                            var c = Object.keys(history).length / 2;
                            history["edit" + c] = edit;
                            var d = (currDate.getDate() < 10) ? "0" + currDate.getDate() : currDate.getDate();
                            var m = ((currDate.getMonth() + 1) < 10) ? "0" + (currDate.getMonth() + 1) : (currDate.getMonth() + 1);
                            var y = currDate.getFullYear();
                            history["date" + c] = d + "." + m + "." + y;
                        }
                        
                    }
					
					if (limit !== '') {
						var limitDateTime = limit.split(' ')[0];
						var limitDateDate = limit.split(' ')[1];
						var limitDateYear = parseInt(limitDateDate.substring(6));
						var limitDateMonth = (parseInt(limitDateDate.substring(3,5))-1);
						var limitDateDay = parseInt(limitDateDate.substring(0, 2));
						var limitDateminutes = parseInt(limitDateTime.substring(3));
						var limitDatehours = parseInt(limitDateTime.substring(0, 2));
						var limitDate = new Date(limitDateYear,limitDateMonth,limitDateDay,limitDatehours,limitDateminutes);
						
						$('input[name="dateField2Year"]').val(limitDate.getFullYear());
						$('input[name="dateField2Month"]').val(limitDate.getMonth());
						$('input[name="dateField2Day"]').val(limitDate.getDate());
						$('input[name="dateField2Hour"]').val(limitDate.getHours());
						$('input[name="dateField2Minute"]').val(limitDate.getMinutes());
						$('input[name="dateField2Second"]').val(limitDate.getSeconds());
						$('input[name="deleteDateField2"]').val('false');
					} else {
						$('input[name="dateField2Year"]').remove();
						$('input[name="dateField2Month"]').remove();
						$('input[name="dateField2Day"]').remove();
						$('input[name="dateField2Hour"]').remove();
						$('input[name="dateField2Minute"]').remove();
						$('input[name="dateField2Second"]').remove();
						$('input[name="deleteDateField2"]').val('true');
					}
					
					if (recResponsableDate !== '' && $('.audition-forms-recording-responsable:checked').val() === 'true' && !isVideo) {
						var recResponsableDateDateTime = recResponsableDate.split(' ')[0];
						var recResponsableDateDateDate = recResponsableDate.split(' ')[1];
						var recResponsableDateDateYear = parseInt(recResponsableDateDateDate.substring(6));
						var recResponsableDateDateMonth = (parseInt(recResponsableDateDateDate.substring(3,5))-1);
						var recResponsableDateDateDay = parseInt(recResponsableDateDateDate.substring(0, 2));
						var recResponsableDateDateminutes = parseInt(recResponsableDateDateTime.substring(3));
						var recResponsableDateDatehours = parseInt(recResponsableDateDateTime.substring(0, 2));
						var recResponsableDateDate = new Date(recResponsableDateDateYear,recResponsableDateDateMonth,recResponsableDateDateDay,recResponsableDateDatehours,recResponsableDateDateminutes);
						
						$('input[name="dateField3Year"]').val(recResponsableDateDate.getFullYear());
						$('input[name="dateField3Month"]').val(recResponsableDateDate.getMonth());
						$('input[name="dateField3Day"]').val(recResponsableDateDate.getDate());
						$('input[name="dateField3Hour"]').val(recResponsableDateDate.getHours());
						$('input[name="dateField3Minute"]').val(recResponsableDateDate.getMinutes());
						$('input[name="dateField3Second"]').val(recResponsableDateDate.getSeconds());
						$('input[name="deleteDateField3"]').val('false');
					} else {
						$('input[name="dateField3Year"]').remove();
						$('input[name="dateField3Month"]').remove();
						$('input[name="dateField3Day"]').remove();
						$('input[name="dateField3Hour"]').remove();
						$('input[name="dateField3Minute"]').remove();
						$('input[name="dateField3Second"]').remove();
						$('input[name="deleteDateField3"]').val('true');
					}
					
					var contractual = {
						cachet: $('input[name="contractual-cachet"]').val(),
						media: $('input[name="contractual-media"]').val(),
						cycle: $('input[name="contractual-cycle"]').val(),
						market: $('input[name="contractual-market"]').val()
					};
					
					var recording = {
						title: $('input[name="studio-title"]', recordingCtn).val(),
						address: $('input[name="studio-address"]', recordingCtn).val(),
						dates: {}
					};

					recordingDates.each(function (i) {
						recording.dates[i] = {
							date: $(this).attr('data-iso'),
							from: $(this).attr('data-from'),
							to: $(this).attr('data-to')
						};
					});
					
					var directives = {
						detail: tinymce.get($('.form-input[name="directives-detail"]').attr('id')).getContent(),
						files: {}
					};
					
					$('.account-option-item[data-rel="audition-forms-directives-files-item"]:not(.clone)').each(function (e) {
						var file = $(this);
						directives.files[e] = {
							filename: $('.account-option-item-value', file).html(),
							id: file.attr('data-id'),
							ext: file.attr('data-ext')
						};
					});
					
					var scripts = '';
					$('.audition-form-script-item:not(.clone)').each(function (e) {
						var file = $(this);
						var fileId = $(this).attr('data-id');
						
						if (fileId !== undefined) {
							if (scripts !== '') {
								scripts += ',';
							}
							
							scripts += fileId;
						}
					});

					var field4;
					var field14;
					var field21;
					var field24;
					var field25;

					if (isVideo) {
						field4 = accountUtils.formatStringArray('.account-type-list', $('.audition-project-types.video-input'));
						field14 = false;
						field21 = $('.form-input[name="field21"]').attr('data-value');
					} else {
						field4 = accountUtils.formatStringArray('.account-type-list', $('.audition-project-types.audio-input'));
						field14 = $('.audition-forms-recording-responsable:checked').val();
						field21 = '';
					}
                    
                    field24 = $('.form-check-input[name="field24"]')[0].checked;
                    field25 = $('.form-check-input[name="field25"]')[0].checked;

                    var changes = "";
                    if(sendEditNotification){
                        changes = tinymce.get($('.form-input[name="directives-detail"]').attr('id')).getContent();
                    }
                    
					var data = {
						field1: 'audition',
						field2: auditionType,
						field4: field4,
						field6: JSON.stringify(recording),
						field8: JSON.stringify(contractual),
						field9: currForm.attr('data-person-id'),
						field10: JSON.stringify(directives),
						field11: scripts,
						field12: $('.form-input[name="field12"]').attr('data-value'),
						field13: '0',
						field14: field14,
						field16: accountUtils.formatStringArray('.audition-form-region-list'),
						field17: $('.form-input[name="field17"]').attr('data-value'),
						field18: accountUtils.formatStringArray('.audition-form-int-lang-list'),
						field19: $('.form-input[name="field19"]').val(),
						field20: $('.form-input[name="field20"]').attr('data-value'),
						field21: field21,
						field23: JSON.stringify(history),
						field24: field24,
						field25: field25,
						field27: $('.form-input[name="field27"]').attr('data-value'),
						ajax: true,
						friendlyUrlField: 'field3',
						redirectToFriendlyUrl: true
					};

					if (preview) {
						data.preview = true;
					}
					
                    if (publish && (!auditionState || auditionState === '0')) {
                        data.field13 = '1';
                    } else if (!!auditionState) {
                        data.field13 =  auditionState;
                    }
					
					if ($(".audition-type-select").attr("data-value") === '1' && t.hasClass('invites-popup') && data.field13 === '1') {
						goToInvites = true;
					}

                    // Weird stuff here : if we are going to set a data object manually, why are we fetching everything automatically here ?
                    // It messes up checkboxes since it depends on if they are checked or not
					$('input', currForm).each(function () {
                        if ($(this).attr('name') !== 'field24' && $(this).attr('name') !== 'field25') {
                            data[$(this).attr('name')] = $(this).val();
                        }
					});

					//console.log(data);

					// Saving the audition
					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: data,
						method: 'POST',
						success: function (response) {
                            //console.log('Auditions form : ' + response);
							var currRedirectPage = currForm.attr('data-page-name');
							var responseArray = response.substring('success-'.length).split('-');
							auditionId = responseArray[responseArray.length - 1];

							if ($('input[name="id"]', currForm).length === 0) {
								currForm.append(`<input name="id" type="hidden" value="${auditionId}"/>`);
							}
							
							var array = currForm.attr('data-invitees').split(','),
								inviteeIds = [],
								requestTotal = 0,
								redirectFriendlyUrl = response.substring('success-'.length);

							var _complete = function() {
								if (preview) {
									window.open(t.attr('data-redirect'));
									currForm.removeClass('is-processing');
								} else if (requestTotal <= 0) {
									var messageToShow = '?' + ($('.audition-forms').attr('data-edit') === 'true' ? 'auditionEdited' : 'auditionCreated');
									
                                    //&& $('.audition-forms').attr('data-edit') !== 'true'
									if (gotoDetail) {
										if (data.field2 === '1') {
											currRedirectPage = currForm.attr('data-page-invitations');
										} 
										window.location.href = currRedirectPage + '/' + redirectFriendlyUrl + messageToShow;
									} else if(goToInvites) {
										popupRedirect = '/' + redirectFriendlyUrl + messageToShow;
										$('.invites-choice-popup-btn').trigger('click');
									} else if(gotoStay) {
										window.location.href = redirect + '/' + redirectFriendlyUrl + messageToShow;
									} else {
										window.location.href = redirect + messageToShow;
									}
								}
							};

							var _notifyPublic = function() {
                                if (requestTotal <= 0) {
                                    $.ajax({
                                        url: '/action/vcCreateNotification',
                                        data: {
                                            newPublicAudition: true,
                                            label: 'notification-audition-public-published',
                                            values: $('input[name=field3]').val() + ',' + currForm.attr('data-page-domain') + currRedirectPage + '/' + redirectFriendlyUrl,
                                            auditionId: auditionId
                                        },
                                        cache: false,
                                        success: _complete
                                    });
                                }
							};
                            
							if (!preview && sendEditNotification) {
								for (var i = 0; i < array.length; i++) {
									if (array[i] !== undefined && array[i] !== "" && inviteeIds.indexOf(array[i]) === -1) {
										inviteeIds.push(array[i]);
									}
								}
								// Send notifications to all non-declined invitations of this audition
								if (inviteeIds.length !== 0) {
									notificationUtils.sendNotificationPerson(
										inviteeIds.join(','),
										'AUDITION_EDIT',
										data.field3 + "*|||*" + currForm.find(".edit-notification-uri").val(),
										function(){},
										{field8: data.field9}
									);
								} 
							}
							
							if ($scripts.length > 0 || !preview) {
                                requestTotal = $scripts.length;
								$scripts.each(function () {
									var file = $(this);
									var fileId = $(this).attr('data-id');
									// Saving scripts to GenData
									$.ajax({
										url: '/action/manageGenData',
										cache: false,
										method: 'POST',
										data: {
											id: fileId,
											field2: file.find('.form-input[name="audition-form-script-item-title"]').val(),
											field3: file.find('.form-input[name="audition-form-script-item-summary"]').val(),
											field4: file.attr('data-file-id'),
											field5: file.attr('data-filename'),
											field6: file.attr('data-ext'),
											field7: auditionId,
											preservePreviewCache: true,
											ajax: true
										},
										success: function() {
                                            requestTotal--;
											if (publish && auditionType === '0' && !preview) {
												_notifyPublic();
											} else {
												_complete();
											}
										}
									});
								});
							} else if (preview) {
								_complete();
							}
						}
					});
				} else {
					form.showErrorPopupAnimation('audition-recording-dates-error');
					var recordingDatesStep = currForm.find('.audition-forms-recording-dates').closest('.audition-forms-step');
					if (recordingDatesStep.find('.audition-forms-step-content').css('display') !== 'block') {
						recordingDatesStep.find('.audition-forms-header').trigger('click');
					}
					currForm.removeClass('is-processing');
				}
			} else {
				form.showErrorPopupAnimation('audition-min-script-error');
				var scriptsStep = currForm.find('.audition-forms-scripts-files').closest('.audition-forms-step');
				if (scriptsStep.find('.audition-forms-step-content').css('display') !== 'block') {
					scriptsStep.find('.audition-forms-header').trigger('click');
				}
				currForm.removeClass('is-processing');
			}
		} else {
			var errors = currForm.find('.error');
			errors.each(function() {
				if ($(this).closest('.audition-forms-step:not(.selected)').length > 0) {
					$(this).closest('.audition-forms-step:not(.selected)').find('.audition-forms-header').trigger('click');
				}
			});
		}
		
		return false;
	};
	
	var addStudioDateItem = function () {
		var ctn = $(this).closest('.audition-forms-recording');
		var date = $('input[name="studio-date"]', ctn).val();
		var year = parseInt(date.substring(6));
		var month = (parseInt(date.substring(3,5))-1);
		var day = parseInt(date.substring(0, 2));
		var timeFrom = $('input[name="studio-time-from"]', ctn).val();
		var timeTo = $('input[name="studio-time-to"]', ctn).val();
		var dateTS = new Date(year,month,day);
		var isoDate = dateTS.toISOString();
		var newElt = $('.account-option-item[data-rel="audition-recording-dates"].clone', ctn).clone().removeClass('clone');
		
		if (date.length) {
			$('.account-option-item-value', newElt).html(date + ' ' + timeFrom+'-'+timeTo);
			newElt.attr('data-iso', isoDate).attr('data-from', timeFrom).attr('data-to', timeTo);
			
			$('input[name="studio-date"], input[name="studio-time-from"], input[name="studio-time-to"]', ctn).val('');
			
			$('.audition-forms-recording-dates-list', ctn).append(newElt);
		}
	};
	
	var addDirective = function () {
		addDocument($(this), function(newId, ext, filename) {
			var list = $('.audition-forms-directives-files-list');
			var clone = $('.account-option-item[data-rel="audition-forms-directives-files-item"].clone').clone().removeClass('clone');
			
			clone.attr('data-id', newId).attr('data-ext', ext);
			$('.account-option-item-value', clone).html(filename);
			
			list.append(clone);
		});
	};
	
	var addScripts = function () {
		addDocument($(this), function(newId, ext, filename, newGenDataId) {
			var list = $('.audition-forms-scripts-files-list');
			var clone = $('.audition-form-script-item.clone').clone().removeClass('clone');
			var position = list.find('.audition-form-script-item:not(.clone)').length + 1;
			
			clone.attr('data-id', newGenDataId).attr('data-file-id', newId).attr('data-ext', ext).attr('data-filename', filename);
			$('.audition-form-script-item-filename', clone).html(filename);
			clone.find('input[name=audition-form-script-item-title]').val('Script ' + position);
			
			list.append(clone);
		});
	};
	
	var addDocument = function (file, callback) {
		var fileCtn = file.closest('.form-input-big-ctn');
		var files = file[0].files;
		
		if (files !== undefined) {
			if (files.length) {
				fileCtn.addClass('is-processing');
		
				for (var i = 0;i<files.length;i++) {
					
					var re = /(?:\.([^.]+))?$/;
					var ext = re.exec(files[i].name)[1];
					var filename = files[i].name;
					
					var data = new FormData();
					data.append('image', files[i]);
					data.append('customLabel', 'file');
					data.append('directory', 'Audition');
					data.append('ajax', 'true');
					
					$.ajax({
						url: '/action/uploadCroppedImage',
						cache: false,
						contentType: false,
						processData: false,
						method: 'POST',
						data: data,
						success: function (response) {
							var newFileId = response.substring(response.indexOf('mediaId=') + 'mediaId='.length).trim();
							// console.log('file: ' + newFileId);
							
							var newDate = new Date();
							
							$.ajax({
								url: '/action/manageGenData',
								cache: false,
								data: {
									field1: 'script',
									field4: newFileId,
									field5: filename,
									field6: ext,
									field7: auditionId,
									dateField1Year: newDate.getFullYear(),
									dateField1Month: newDate.getMonth(),
									dateField1Day: newDate.getDate(),
									dateField1Hour: newDate.getHours(),
									dateField1Minute: newDate.getMinutes(),
									dateField1Second: newDate.getSeconds(),
									ajax: true
								},
								success: function (genResponse) {
									var newScriptId = genResponse.substring('success-'.length);
									// console.log('script: ' + newScriptId);
									
									fileCtn.removeClass('is-processing');
									form.resetUpload(file);
									
									callback(newFileId, ext, filename, newScriptId);
								} 
							});
						}
					});
				}
			}
		}
	};
	
	var scriptDelClick = function () {
		$(this).closest('.audition-form-script-item').remove();
	};
	
	var stepHeaderClick = function () {
		var t = $(this);
		var currStep = t.closest('.audition-forms-step');
		var currContent = $('.audition-forms-step-content', currStep);
		
		if (currStep.hasClass('selected')) {
			currStep.removeClass('selected');
			currContent.slideUp(300);
		} else {
			currStep.addClass('selected');
			currContent.slideDown(300);
		}
		
		manageSelectedSteps();
	};
	
	var manageSelectedSteps = function () {
		var selectedSteps = $('.audition-forms-step.selected');
		
		$('.audition-forms-step').removeClass('selected-before');
		if (selectedSteps.length) {
			var lastOne = selectedSteps.eq(-1);
			var index = lastOne.index();
			
			for (var i = 0; i < index; i++) {
				$('.audition-forms-step').eq(i).addClass('selected-before');
			}
		}
	};
	
	var goToNextStep = function () {
		var t = $(this);
		var currStep = t.closest('.audition-forms-step');
		var currContent = $('.audition-forms-step-content', currStep);
		var currIndex = currStep.index();
		var nextStep = $('.audition-forms-step').eq(currIndex + 1);
		var nextContent = $('.audition-forms-step-content', nextStep);
		
		var target = currStep.offset().top + stepHeight - $('.site-header').outerHeight();
		
		$('html, body').animate( {scrollTop: (target+'px')}, 300 );
		currStep.removeClass('selected');
		currContent.slideUp(300);
		nextStep.addClass('selected');
		nextContent.slideDown(300);
		manageSelectedSteps();
	};
	
	var auditionTypeToggle = function(){
		var type = $(this).closest(".audition-type-select-ctn").find(".audition-type-select").attr("data-value");
		// console.log(type === '0');
		$('.auditions-form-publish-message').hide();
		if(type === '0'){ // public
			$('.auditions-form-publish-message.public').show();
		} else { //invitation
			$('.auditions-form-publish-message.invite').show();
		}
	};
	
	var recordingToggle = function () {
		if ($(this).val() === 'true') {
			$('.audition-forms-recording-dates-ctn').slideUp(300, function() {
				$(this).find('input').val('');
				$(this).find('.account-option-item:not(.clone)').remove();
			});
			$('.audition-forms-recording-responsable-ctn').slideDown(300);
		} else {
			$('.audition-forms-recording-responsable-ctn').slideUp(300, function() {
				$(this).find('input').val('');
			});
			$('.audition-forms-recording-dates-ctn').slideDown(300);
		}
	};

	var initCheckPageLeave = function() {
		if (!checkingPageLeave) {
			checkingPageLeave = true;
			$('a').click(function(event) {
				checkPageLeave(event, $(this));
			});
		}
	};

	var checkPageLeave = function(event, link) {
		event.preventDefault();

		pageLeaveUrl = link.attr('href');

		$('.leave-page-popup-btn').trigger('click');
	};

	var confirmPageLeave = function() {
		window.location.href = pageLeaveUrl;
	};

	var forwardToInvitesPage = function() {
		$(this).closest('.popup').addClass('is-processing');
		window.location.href = redirectInvites + popupRedirect;
	};

	// @param   region   optional (ids of gendata available-region)
	var inviteAllAgencies = function(regions) {
		var popup = $(this).closest('.popup');
		var agenciesIds = popup.find('.all-agencies-invites-details').attr('data-ids');
//		console.log('before:', agenciesIds)
		if (regions && regions.length > 0) {
			agenciesIds = popup.find('.all-agencies-invites-details').attr('data-ids-with-regions').split(';')
			.filter((s) => {
				return s.split('|')[1].split(',').some(region => regions.split(',').indexOf(region) >= 0);
			}).map((s) => {
				return s.split('|')[0];
			}).join(",");
		}
//		console.log('after:', agenciesIds)
		
		popup.addClass('is-processing');
		var data = {
			auditionId: auditionId,
			personIds: agenciesIds,
			// jsons: jsons,
			ajax: true
		};
//		console.log(data)

		$.ajax({
			url: '/action/vcSendAuditionInvitations',
			cache: false,
			method: 'POST',
			data: data,
			success: function (response) {
//				console.log('Invite : ' + response);
				notificationUtils.sendNotificationPerson(
					agenciesIds, 
					'AUDITION_AGENCY',
					encodeURIComponent($('.form-input[name=field3]').val()) + '*|||*' + popup.find('.all-agencies-invites-details').attr('data-notif-url'),
					function() {
						window.location.href = redirect + popupRedirect;
					},
					{ field8: searcherId }
				);
			}
		});
	};

	var handleAuditionTypeSpecificInputs = function() {
		var val = $(this).val();

		if (val === '0') {
    		$('.video-input').slideUp(function() {
    			$('.audio-input').slideDown();
    		});
    	} else {
    		$('.audio-input').slideUp(function() {
    			$('.video-input').slideDown();
    		});
		}
	};
    
    var showDetail = function(){
        $(".edit-notification-detail").toggleClass("hide");
    };
    
    var sendInvitesPopupBtnClick = function() {
    	var popup = $(this).closest('.popup');
    	var selectedOption = $('[name=invite-agencies-radio]:checked').val();
    	
    	if (selectedOption == "all-agencies") {
    		var regions = '';
    		var selectedRegions = popup.find('.account-option-item:not(.clone)');
    		selectedRegions.each(function(i) {
    			regions += $(this).attr('data-value');
    			if (i + 1 < selectedRegions.length) {
    				regions += ',';
    			}
    		});
    		inviteAllAgencies.call(this, regions);
    	} 
    	else {
    		popup.addClass('is-processing');
    		window.location.href = redirectInvites + popupRedirect;
    	}
    };

    var showDetail = function(){
        $(".edit-notification-detail").toggleClass("hide");
    }
      
//	var changeStudioFilter = function() {
//		var t = $(this);
//
//        if (sourceConnectChk.is(":checked")) {
//            t.prop('checked', true);
//            return;
//        }
//	};
//    
//	var changeSourceConnectFilter = function() {
//		var t = $(this);
//
//
//		if (t.is(':checked')) {
//            studioChk.prop("checked", true);
//		}
//
//	};
    
	var init = function () {
		form = Fw.component.models().form;
		notificationUtils = Fw.component.models().notificationUtils;
		accountUtils = Fw.page.models().account;
		customSelect = Fw.component.models().customSelect;
		
		auditionId = $('input[name="id"]').val();
		auditionState = $('input[name="audition-state"]').val();
		currForm = $('.auditions-form');
		formSubmit = $('.auditions-form-btn');
		publishCtn = $('.auditions-form-publish-ctn');
		stepHeader = $('.audition-forms-header');
		stepNextBtn = $('.audition-forms-step-next-btn');
		stepHeight = $('.audition-forms-step:not(.selected)').outerHeight();
		addStudioDate = $('.audition-forms-recording-dates-add');
		directivesInput = $('.form-item-upload-input[name="audition-forms-directives-files-input"]');
		scriptsInput = $('.form-item-upload-input[name="audition-forms-scripts-files-input"]');
		scriptAdd = $('.audition-forms-scripts-files-submit');
		auditionType = $(".audition-type-select-ctn .select-option");
		recordingCheck = $('.audition-forms-recording-responsable');
		searcherId = $('.audition-single-audition-researcher-id').val();
		sendEditNotificationCheck = $('.auditions-form-notify-check');
		sendInvitesPopupBtn = $('.send-invites-popup-btn');
		studioChk = $('.auditions-invitation-studio-chk');
		sourceConnectChk = $('.auditions-invitation-sourceConnect-chk');
		
		currForm.find('.form-input').each(function() {
			$(this).blur(initCheckPageLeave);
		});
		$('.confirm-page-leave-btn').click(confirmPageLeave);
		formSubmit.click(submitAudition);
		addStudioDate.click(addStudioDateItem);
		directivesInput.change(addDirective);
		scriptsInput.change(addScripts);
		$('body').on('click', '.audition-form-script-item-del', scriptDelClick);
		stepHeader.click(stepHeaderClick);
		stepNextBtn.click(goToNextStep);
		auditionType.on("click", auditionTypeToggle);
		recordingCheck.change(recordingToggle);
		$('.forward-to-invites-page-btn').click(forwardToInvitesPage);
		$('.invite-all-agencies-btn').click(inviteAllAgencies);
		$('.audition-file-type-select').change(handleAuditionTypeSpecificInputs);
		sendEditNotificationCheck.click(showDetail);
		sendInvitesPopupBtn.on('click', sendInvitesPopupBtnClick);
		
		$('.popup[data-id=invites-choice-popup]').on('popup_closed', function() {
			$('.auditions-form').removeClass('is-processing');
		});
		
		$('.form-input[name="field16"]', currForm).on('change', function() {
			var regionId = $(this).attr('data-value');
			var regionSelect = $('.invites-choice-popup').find('[name=region]');
			regionSelect.val(regionId);
		});
        
		win.resize(function() {
			if (win.width() != winWidth) {
				winHeight = win.height();
				winWidth = win.width();
				
				if ($('.audition-forms-step:not(.selected)').length) {
					stepHeight = $('.audition-forms-step:not(.selected)').outerHeight();
				} else {
					$('.audition-forms-step').eq(0).removeClass('selected').find('.audition-forms-step-content').slideUp(0);
					stepHeight = $('.audition-forms-step').eq(0).outerHeight();
					$('.audition-forms-step').eq(0).addClass('selected').find('.audition-forms-step-content').slideDown(0);
				}
			}
		});
        
//		studioChk.click(changeStudioFilter);
//		sourceConnectChk.click(changeSourceConnectFilter);
	};
	
	$(window).ready(init);
	
})(jQuery);
